import actions from "@/store/notice/actions";
import state from "@/store/notice/states";
import mutations from "@/store/notice/mutations";

const NoticeModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default NoticeModule;